import React, { ReactNode } from "react";

import "./CartBet.module.scss";
import PropTypes from "prop-types";

const CartBet = React.forwardRef(function CartBetWithRef({ guesses, onRemoveClick }, ref) {
	return <React.Fragment>
			{(guesses || []).map((guess) => {
				return <div className={`cartBet__cartBet ${guess.amount ? "showAmount" : ""}`} ref={ref} data-alternativetext={guess.alternativeText} data-amounttext={"x" + guess.amount}>
					{guess.displayText || guess.number}
					<div className={"cartBet__removeButton"} onClick={() => {
						if(onRemoveClick) onRemoveClick(guess.number)
					}}><span>-</span></div>
				</div>
			})}

		
	</React.Fragment>
});

CartBet.propTypes = {
    guesses: PropTypes.arrayOf(PropTypes.shape({
		number: PropTypes.number.isRequired,
		alternativeText: PropTypes.string,
		displayText: PropTypes.string,
		amount: PropTypes.number,
	})).isRequired,
    theme: PropTypes.object,
	onClick: PropTypes.func
};

export default CartBet;


// WEBPACK FOOTER //
// ./src/rifa/components/layout/cart/CartBet.jsx